<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title12"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9781429924122_tp01" id="toctitle9" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<a class="toc_entry_chapter" href="#/e9781429924122_c01" id="toctitle1"><span><strong class="b">I</strong> - <strong class="b">1840</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/e9781429924122_c02" id="toctitle2" title="Link target outside of Sample"><span><strong class="b">II</strong> - <strong class="b">1848</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429924122_c03" id="toctitle3" title="Link target outside of Sample"><span><strong class="b">III</strong> - <strong class="b">1867</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429924122_c04" id="toctitle4" title="Link target outside of Sample"><span><strong class="b">IV</strong> - <strong class="b">1894-2004</strong></span></span><br/>
<span class="toc_entry_alsoby" href="#/e9781429924122_als01" id="toctitle5" title="Link target outside of Sample"><span><strong class="b">Also by Vivian Gornick</strong></span></span><br/>
<span class="toc_entry_aboutAuthorPage" href="#/e9781429924122_ata01" id="toctitle6" title="Link target outside of Sample"><span><strong class="b"><em class="i">The Solitude of Self</em></strong></span></span><br/>
<span class="toc_entry_praisePage" href="#/e9781429924122_pra01" id="toctitle7" title="Link target outside of Sample"><span><strong class="b">Praise for <em class="i">The Solitude of Self</em></strong></span></span><br/>
<span class="toc_entry_backMatter" href="#/e9781429924122_bm01" id="toctitle8" title="Link target outside of Sample"><span><strong class="b">BIBLIOGRAPHICAL NOTE</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781429924122_cop01" id="toctitle10" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429924122_toc01.vue?784bfb3f